import React,{useState,useEffect} from 'react'
import clinicService from '../../services/clinic.service'
const SideBar = ({clinic}) => {
    const [hours,setHours] = useState()
    useEffect(()=>{
        clinicService.getHours(clinic.ID)
        .then(res=>{
            //console.log(res.data)
            setHours(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    },[])

    const day = (days)=>{
        
        return <tr key={days.ID}>
           <td><small>{days.day}</small></td>
            <td><small>{days.start}</small> to <small>{days.end}</small> </td>
            
        </tr>
    }
    return ( 
        <>
           
            <div className="alert alert-secondary mt-4">
                 <div className="d-flex flex-column">
                        <div className="d-flex flex-row ms-3 me-3 mt-3">
                            <h2 className="me-4"><i className="bi bi-geo-alt-fill"></i></h2>
                            <p>{clinic.street + " "+clinic.city+". "+clinic.province+" "+clinic.postalCode}</p>
                        </div>
                        <div className="d-flex flex-row ms-3 me-3 mt-2">
                              <h2 className="me-4"><i className="bi bi-telephone-fill"></i></h2>
                            <p>{clinic.phone}</p>
                        </div>
                        <div className="d-flex flex-row ms-3 me-3 mt-2">
                              <h2 className="me-4"><i className="bi bi-send-fill"></i></h2>
                            <p>{clinic.email}</p>
                        </div>
                        <div className="d-flex flex-row m-3">
                              <h2 className="me-4"><i className="bi bi-globe"></i></h2>
                             <p>{clinic.website}</p>
                        </div>
                        
                        <div>
                            <table className='table table-sm'>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Hours of Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {hours && hours.map(day)}
                                </tbody>
                              
                            </table>
                        </div>
                      
                </div>
              
            </div> 
        </>
     );
}
 
export default SideBar;